
import { computed, defineComponent, ref } from 'vue';

enum PILL_VARIANTS {
  NEUTRAL = 'neutral',
  INFORMATIVE = 'informative',
  ALARMING = 'alarming',
  PASSIVE = 'passive'
}

export default defineComponent({
  name: 'BasePill',

  props: {
    variant: {
      type: String,
      default: 'neutral',
      validator: (value: string) => {
        return [...(Object.values(PILL_VARIANTS) as string[])].includes(value);
      }
    }
  },
  setup(props) {
    const pill = ref(null);
    const classes = computed(() => {
      return `base-pill--${props.variant}`;
    });

    return {
      classes,
      pill
    };
  }
});
